module.exports = __webpack_public_path__ + "static/img/Advanced-Torso-CT4.458dddc8.png";